import createjs, { Point } from 'createjs-module';
import { Dimensions } from '../../../../../../../globals/Dimensions';
import { GridItem } from './GridItem';

export class Grid extends createjs.Container {
  
  _mousePoisition?: Point;
  _isInDragMode: boolean = false;
  _gridItems?: Array<GridItem>;

  _onGridSizeSelected: Function | null = null;

  _totalSelectedRows: number = 3;
  _totalSelectedColumns: number = 3;

  constructor() {
    super();
  }

  createBackground(){
    var rectOff = new createjs.Shape();
    rectOff.graphics
      .setStrokeStyle(1)
      .beginStroke('#D3D3D3')
      .beginFill('#FFFFFF')
      .drawRoundRect(0, 0, 218, 218, 5);
    this.addChild(rectOff);
  }

  public set onGridSizeSelected(value: Function){
    this._onGridSizeSelected = value;
  }

  init() {

    this.setBounds(0,0,218,218);
    this.createBackground();

    let totalColumns = 7;
    let totalRows = 7;

    let offsetX = 10;
    let offsetY = 10;
    
    this._gridItems = new Array<GridItem>();
    
    for (let i = 0; i < totalRows; i++) {
        
        for (let j = 0; j < totalColumns; j++) {
            
            var gridItem = new GridItem()
            gridItem.init()

            this.addChild(gridItem)

            gridItem.y = offsetY + (gridItem.getBounds().height + 5) * i
            gridItem.x = offsetX + (gridItem.getBounds().width + 5) * j

            this._gridItems.push(gridItem);
        }
    }

    this.addEventListener('click', (e: any) => {
          this._mousePoisition = new Point(e.stageX, e.stageY)

          console.log("-----------------")
          console.log(this._mousePoisition?.x, this._mousePoisition?.y)

          this.showSelectedInnerGrid()
    })

    this.addEventListener('mousedown', (e: any) => {
      this._isInDragMode = true
    })

    this.addEventListener('pressup', (e: any) => {
      this._isInDragMode = false

      if(this._onGridSizeSelected){
        this._onGridSizeSelected(this._totalSelectedRows, this._totalSelectedColumns);
      }
    })

    this.addEventListener('pressmove', (e: any) => {
      if(!this._isInDragMode){
        return;
      }

      this._mousePoisition = new Point(e.stageX, e.stageY)

      // console.log("-----------------")
      // console.log(this._mousePoisition?.x, this._mousePoisition?.y)

      this.showSelectedInnerGrid()
    })
  }

  showSelectedInnerGrid() {

    let totalColumns = 7;
    let totalRows = 7;

    let mousePoisition = this._mousePoisition;
    let mouseX = mousePoisition!.x - 10
    let mouseY = mousePoisition!.y - 10

    let relatedRow =  Math.floor(mouseY / 24.0)
    let relatedColumn =  Math.floor(mouseX / 24.0)

    if(relatedRow >= 1) {
      mouseY -= (relatedRow - 1) * 5
    }

    if(relatedColumn >= 1) {
      mouseX -= (relatedColumn - 1) * 5
    }

    relatedRow = Math.floor(mouseY / 24.0)
    relatedColumn =  Math.floor(mouseX / 24.0)

    let gridItems = this._gridItems!;

    
    for (let i = 0; i < totalRows; i++) {
        
      for (let j = 0; j < totalColumns; j++) {

        let index = i * totalColumns + j
        const gridItem = gridItems[index];

        if(i <= relatedRow && j <= relatedColumn){ 
          gridItem.showSelected(true)
          //console.log(`show grid item (${i},${j})`)
        }
        else {
          gridItem.showSelected(false)
        }
      }
    }

    // none zero
    this._totalSelectedRows = relatedRow + 1;
    this._totalSelectedColumns = relatedColumn + 1;

    this.stage.update();
  }
}
